import FaxNumberFormPanel from './FaxNumberFormPanel';

export default FaxNumberFormPanel;


// WEBPACK FOOTER //
// ./src/components/forms/FaxNumberFormPanel/index.js